<template>
  <el-dialog
      title="渠道添加"
      :visible.sync="dialogVisible"
      width="80%"
      @close="close"
      top="4vh"
  >
    <div class="box-card" v-if="Object.keys(infoData).length">
      <template v-if="infoData.orderItems.length">
        <el-row
            class="custom-container flex"
            v-for="item in infoData.orderItems"
            :key="item.id"
        >
          <el-col :span="4">
            <div v-if="item.imageUrl">
              <el-image
                  style="width: 100%; height: 100%;"
                  :src="item.imageUrl"
                  :preview-src-list="item.imageUrl.split(',')"
              ></el-image>
            </div>
            <el-row
                type="flex"
                justify="center"
                align="middle"
                v-else
            >
              <el-button
                  type="text"
                  size="mini"
                  @click="getOriginalImg(item)"
              >查看原图
              </el-button
              >
            </el-row>
          </el-col>
          <el-col :span="18" :offset="2">
            <div class="inform flex">
              <div class="title">亚马逊订单号：</div>
              <div>{{ infoData.amazonOrderId }}</div>
            </div>
            <!-- <div class="inform flex">
              <div class="title">标题：</div>
              <div>{{ item.title }}</div>
            </div>-->
            <div class="inform flex">
              <div class="title">销售链接：</div>
              <el-link
                  type="primary"
                  :underline="false"
                  @click="openLink(item)"
              >{{ item.saleLink }}
              </el-link
              >
            </div>
            <div class="inform flex">
              <div class="title">SKU：</div>
              <div>{{ item.sellerSKU }}</div>
            </div>
            <el-row type="flex" justify="space-between">
              <div class="inform flex">
                <div class="title">数量：</div>
                <div>{{ item.quantityOrdered }}</div>
              </div>
            </el-row>
            <el-row type="flex" justify="space-between">
              <div class="inform flex">
                <div
                    class="title"
                    style="color:red;font-size: 18px;"
                >
                  订单状态：
                </div>
                <div
                    style="color:red;font-size: 18px;font-weight: bold;"
                >
                  {{ item.orderStatus }}
                </div>
              </div>
            </el-row>
            <el-row type="flex" style="align-items: center;">
              <el-tag
                  v-if="sondata.outInterceptStatus === 1"
                  type="danger"
                  effect="dark"
                  style="font-size: 18px;"
              >拦截
              </el-tag
              >
              <el-tooltip
                  class="item"
                  effect="dark"
                  content="订单冻结"
                  placement="bottom"
                  v-if="sondata.isFreeze === 1"
              >
                <i
                    class="element-icons hx-snow"
                    style="font-size: 40px;color: #1296db;line-height: 40px;"
                ></i>
              </el-tooltip>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <!-- <div class="custom-container" v-if="storageInfo.length">
        <el-divider></el-divider>
        <el-row type="flex">
          <el-col :span="2">入库参数：</el-col>
          <el-col :span="22">
            <template v-for="item in storageInfo">
              <el-row type="flex" align="middle" :key="item.id" style="margin-bottom:10px;">
                <el-col :span="6">采购单号：{{ item.purchaseNumber || "" }}</el-col>
                <el-col :span="4">{{ item.purchaseSize || "" }}</el-col>
                <el-col :span="4">
                  {{ item.purchaseWeight || "" }}
                  <span v-if="item.purchaseWeight">KG</span>
                </el-col>
                <el-col :span="4">{{ item.purchaseTypeCode || "" }}</el-col>
              </el-row>
            </template>
          </el-col>
        </el-row>
      </div>-->
      <!-- <div
        class="custom-container"
        v-if="infoData.orderPackPrices && infoData.orderPackPrices.length"
      >
        <div style="width:100%;">
          <el-divider></el-divider>
          <el-row type="flex">
            <div class="inform" style="flex-shrink:0;line-height:50px;">包材设置：</div>
            <div style="width:90%;">
              <el-col
                class="inform"
                :span="20"
                style="padding: 10px 0px;"
                v-for="(item, index) in infoData.orderPackPrices"
                :key="index"
              >
                <el-col :span="4">类型：{{ item.priceName }}</el-col>
                <el-col :span="4" :offset="1">数量：{{ item.packCount }}</el-col>
                <el-col :span="4" :offset="1">{{ item.priceValueTotal }}CNY</el-col>
              </el-col>
            </div>
          </el-row>
        </div>
      </div>-->
      <el-divider></el-divider>
      <div class="custom-container">
        <el-row type="flex" align="middle" style="margin-bottom: 10px">
          <h4 style="margin-right:20px;">买家姓名</h4>
          <span style="margin-right:20px;">{{ infoData.buyerName }}</span>
          <h4 style="margin-right:20px;">买家邮箱</h4>
          <span>{{ infoData.buyerEmail }}</span>
        </el-row>
        
        <el-row type="flex" justify="space-between" align="middle">
          <el-row type="flex" align="middle">
            <h4 style="margin-right:20px;">收件人信息</h4>
            <el-button
                type="success"
                size="mini"
                v-if="isReceiverEdit"
                @click="confirmAddresseeInfo"
                :loading="loadingInfo"
            >完成
            </el-button
            >
            <el-button
                type="primary"
                size="mini"
                v-else
                @click="isReceiverEdit = true"
            >编辑
            </el-button
            >
          </el-row>
          <!-- <el-button type="text" @click="isInfoAddressShow = !isInfoAddressShow">{{isInfoAddressShow?'收起':'展开'}}</el-button> -->
        </el-row>
        <!-- :rules="rulesInner2" -->
        <!-- v-show="isInfoAddressShow" -->
        <el-form
            ref="infoAddress"
            :model="infoAddress"
            style="margin-top:10px;"
            class="custom-formItem"
            label-width="100px"
            inline
        >
          <el-form-item label="国家" prop="countryCode">
            <el-input
                v-model="infoAddress.countryCode"
                :readonly="!isReceiverEdit" 
            ></el-input>
          </el-form-item>
          <el-form-item label="州" prop="stateOrRegion">
            <el-input
                v-model="infoAddress.stateOrRegion"
                :readonly="!isReceiverEdit" 
            ></el-input>
          </el-form-item>
          <el-form-item label="市" prop="city">
            <el-input
                v-model="infoAddress.city"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人" prop="name">
            <el-input
                v-model="infoAddress.name"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="TEL" prop="phone">
            <el-input
                v-model="infoAddress.phone"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="ZIP" prop="postalCode">
            <el-input
                v-model="infoAddress.postalCode"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址1" prop="addressLine1">
            <el-input
                v-model="infoAddress.addressLine1"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址2" prop="addressLine2">
            <el-input
                v-model="infoAddress.addressLine2"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址3" prop="addressLine3">
            <el-input
                v-model="infoAddress.addressLine3"
                :readonly="!isReceiverEdit"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="custom-container">
        <el-row type="flex" align="middle">
          <h4 style="margin-right:20px;">国际运单</h4>
          <el-button type="primary" @click="dialogInnerVisible"
          >添加
          </el-button
          >
          <el-button type="primary" @click="createThirdChannel"
          >新增第三方物流
          </el-button
          >
          <el-button
              type="primary"
              @click="channelChange"
              v-if="parentType === 'revise'"
          >渠道确认
          </el-button
          >
        </el-row>
        <div v-if="infoChannel.length" style="margin-top: 10px;">
          <el-card
              shadow="hover"
              v-for="item in infoChannel"
              :key="item.id"
          >
            <el-row type="flex">
              <div class="channel-flex">
                <h4>渠道：</h4>
                <span v-if="item.type == 1">三态</span>
                <span v-if="item.type == 2">云途</span>
                <span v-if="item.type == 3">燕文</span>
                <span v-if="item.type == 4">第三方</span>
                <span v-if="item.type == 5">k5</span>
                <span v-if="item.type == 6">递四方</span>
                <span v-if="item.type == 7">云途（服装）</span>
                <span v-if="item.type == 8">泰嘉</span>
                <span v-if="item.type == 9">八达通</span>
                <span v-if="item.type == 10">云途A</span>
                <span v-if="item.type == 11">递四方A</span>
                <span v-if="item.type == 12">捷岸</span>
                <span v-if="item.type == 13">立德</span>
                <span v-if="item.type == 14">艾姆勒</span>
                <span v-if="item.type == 15">shopee物流</span>
                <span v-if="item.type == 16">ozon物流</span>
                <span v-if="item.type == 17">柏电</span>
                <span v-if="item.type == 18">柏电自有</span>
                <span v-if="item.type == 19">万立德</span>
                <span v-if="item.type == 20">浩亿达</span>
                <span v-if="item.type == 21">Cheer</span>
                <span v-if="item.type == 22">辰达通</span>
                <span v-if="item.type == 23">辰达通A</span>
                <span v-if="item.type == 24">浩亿达_厦门</span>
                <span v-if="item.type == 25">艾派</span>
                <span v-if="item.type == 26">艾派_厦门</span>
                <span v-if="item.type == 27">dealfy</span>
                <span v-if="item.type == 28">菜鸟</span>
                <span v-if="item.type == 29">艾派COD</span>
                <span v-if="item.type == 30">欧邮通</span>
                <span v-if="item.type == 31">菜鸟-海度</span>
                <span v-if="item.type == 32">速卖通物流</span>
                <span v-if="item.type == 33">Walmart_SWW</span>
                <span v-if="item.type == 34">商壹国际</span>
              </div>
              <div class="channel-flex" v-if="item.orderChannelId">
                <h4>订单渠道id：</h4>
                {{ item.orderChannelId }}
              </div>
              <div class="channel-flex">
                <h4>运单号：</h4>
                {{ item.conveyNumber }}
              </div>
              <div class="channel-flex">
                <h4>追踪号：</h4>
                {{ item.trackNumber }}
              </div>
              <div class="channel-flex">
                <h4>转单号：</h4>
                {{ item.transferOrderNumber }}
              </div>
            </el-row>
            <el-row type="flex" justify="space-between">
              <el-row type="flex">
                <div class="channel-flex">
                  <h4>国家：</h4>
                  {{ item.countryName }}
                </div>
                <div class="channel-flex">
                  <h4>路线：</h4>
                  {{ item.channelWay }}
                </div>
                <div class="channel-flex">
                  <h4>时间：</h4>
                  {{ item.createTime }}
                </div>
              </el-row>
              <div class="right-btn-container">
                <el-button
                    class="padding0"
                    type="text"
                    @click="toVoid(item)"
                    v-if="item.status !== 1"
                >作废
                </el-button
                >
                <div
                    v-else
                    style="color:red;margin-right:10px;"
                >
                  已作废
                </div>

                <el-button
                    class="padding0"
                    type="text"
                    @click="openPrintPage(item)"
                >打印({{
                    item.printfCount || 0
                  }})
                </el-button
                >
                <!-- <el-button class="padding0" type="text">明细</el-button> -->
              </div>
            </el-row>
          </el-card>
        </div>

        <!-- <div class="custom-container" style="margin-top:30px;">
      <div style="width:100%;">
        <el-row type="flex">
          <el-collapse style="width:100%;margin-top:30px;">
            <el-collapse-item title="物流内部备注">
              <div><el-button type="primary" size="mini" @click="InRemarks = true">添加备注</el-button></div>
              <el-divider></el-divider>
              <div style="display: flex;justify-content: space-between;margin-top:15px;" v-for="item in this.RemarkList">
                <p style="width:10%;">{{item.roleName}}</p>
                <p style="width:75%;">{{item.remarkContent}}</p>
                <p style="width:15%;">{{item.createTime}}</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </div>
    </div> -->

        <el-dialog
            width="30%"
            title="添加物流内部备注"
            :visible.sync="InRemarks"
            append-to-body
        >
          <el-input v-model="remarksInput"></el-input>
          <div slot="footer" class="dialog-footer">
            <el-button @click="InRemarks = false">取 消</el-button>
            <el-button type="primary" @click="AddRemarks"
            >确定
            </el-button
            >
          </div>
        </el-dialog>

        <div style="margin-top:20px;">
          <el-tabs type="border-card">
            <el-tab-pane label="国际物流备注">
              <div style="width:100%;display: flex;">
                <el-button type="primary" @click="AddChannel"
                >添加备忘录
                </el-button
                >
                <span v-for="item in momoList" :key="item.id">
									<el-tag
                      style="margin-left:10px;border:0;"
                      v-for="tag in item.channelMarkItems"
                      :color="tag.itemName"
                      :key="tag.id"
                      effect="dark"
                      size="mini"
                      :type="tag.type"
                  >{{ tag.itemTypeName }}</el-tag
                  >
								</span>
              </div>

              <div
                  class="borbuttom"
                  v-for="item in momoList"
                  :key="item.id"
              >
                <div
                    style="display: flex;justify-content: left;margin-top:15px;"
                >
                  <p style="width:150px;">
                    {{ item.roleUserName }}:
                  </p>
                  <div style="margin-top: 11px;">
                    <el-image
                        class="voucher"
                        style="width: 30px; height: 30px"
                        :src="item.repayImage.url"
                        :preview-src-list="
												item.repayImage
													.repayCredentialsList
											"
                    >
                      <div
                          slot="error"
                          class="image-slot"
                      >
                        <img
                            src="../../../assets/imags/暂无图片.png"
                            alt
                            style="width:30px;height:25px;"
                        />
                      </div>
                    </el-image>
                  </div>
                  <p style="width:100%;margin-left:30px;">
                    {{ item.remarkContent }}
                  </p>
                </div>
                <div
                    style="margin-top:10px;height:30px;"
                    v-if="item.channelMarkItems !== null"
                >
                  <span>国际:</span>
                  <el-tag
                      style="margin-left:10px;border:0;"
                      v-for="tag in item.channelMarkItems"
                      :color="tag.itemName"
                      :key="tag.id"
                      effect="dark"
                      size="mini"
                      :type="tag.type"
                  >{{ tag.itemTypeName }}
                  </el-tag
                  >
                </div>
                <div style="height:22px;">
									<span
                      style="float:right;color:#409eff;cursor: pointer;"
                      v-if="item.remarkStatus == 1"
                      @click="OpenToDealWith(item)"
                  >待处理</span
                  >
                  <span
                      style="float:right;"
                      v-if="item.remarkStatus == 2"
                  >已处理</span
                  >
                  <span
                      style="float:right;"
                      v-if="item.remarkStatus == 3"
                  >已完结</span
                  >
                  <span
                      style="float:right;margin-right:20px;"
                  >{{ item.createTime }}</span
                  >
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="物流内部备注">
              <div style="width:100%;display: flex;">
                <el-button
                    type="primary"
                    @click="InRemarks = true"
                >添加物流内部备注
                </el-button
                >
              </div>

              <div v-for="(item, i) in this.RemarkList" :key="i">
                <div
                    style="display: flex;justify-content: space-between;margin-top:15px;"
                >
                  <p style="width:10%;">
                    {{ item.roleName }}
                  </p>
                  <p style="width:75%;">
                    {{ item.remarkContent }}
                  </p>
                  <p style="width:15%;">
                    {{ item.createTime }}
                  </p>
                </div>
                <el-divider></el-divider>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="confirmOperate">完 成</el-button>
		</span>

    <international-channel
        ref="InternationalChannel"
        @close="dialogClose"
        @refreshData="
				getInfo()
				$emit('close')
			"
    />

    <el-dialog
        width="70%"
        title="新增第三方物流"
        :visible.sync="innerThirdVisible"
        append-to-body
        @close="dialogClose('third')"
    >
      <!-- <div class="custom-container">
        <el-row type="flex" align="middle">
          <h4 style="margin-right:20px;">收件人信息</h4>
          <el-button
            type="success"
            size="mini"
            v-if="isReceiverEdit"
            @click="isReceiverEdit = false"
          >完成</el-button>
          <el-button type="primary" size="mini" v-else @click="isReceiverEdit = true">编辑</el-button>
        </el-row>
        <el-form
          ref="infoAddress"
          label-width="80px"
          :model="infoAddress"
          style="overflow:hidden;margin-top:10px;"
        >
          <el-col :span="8">
            <el-form-item label="国家" prop="countryCode">
              <el-input v-model="infoAddress.countryCode" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="州" prop="stateOrRegion">
              <el-input v-model="infoAddress.stateOrRegion" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="市" prop="city">
              <el-input v-model="infoAddress.city" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收件人" prop="name">
              <el-input v-model="infoAddress.name" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="TEL" prop="phone">
              <el-input v-model="infoAddress.phone" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="ZIP" prop="postalCode">
              <el-input v-model="infoAddress.postalCode" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地址1" prop="addressLine1">
              <el-input v-model="infoAddress.addressLine1" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地址2" prop="addressLine2">
              <el-input v-model="infoAddress.addressLine2" :readonly="!isReceiverEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>-->
      <!-- <el-divider></el-divider>
      <el-row
        class="custom-container flex"
        v-if="Object.keys(infoData).length && infoData.orderItems.length"
      >
        <el-col :span="4">
          <el-image
            style="width: 100%; height: 100%;"
            :src="infoData.orderItems[0].imageUrl"
            :preview-src-list="infoData.orderItems[0].imageUrl.split(',')"
          ></el-image>
        </el-col>
        <el-col :span="18" :offset="2">
          <div class="inform flex">
            <div class="title">亚马逊订单号：</div>
            <div>{{ infoData.amazonOrderId }}</div>
          </div>
          <div class="inform flex">
            <div class="title">标题：</div>
            <div>{{ infoData.orderItems[0].title }}</div>
          </div>
          <div class="inform flex">
            <div class="title">SKU：</div>
            <div>{{ infoData.orderItems[0].sellerSKU }}</div>
          </div>
          <div class="inform flex">
            <div class="title">数量：</div>
            <div>{{ infoData.orderItems[0].quantityOrdered }}</div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>-->
      <el-form
          ref="formInnerThird"
          :model="formInnerThird"
          :rules="rulesInnerThird"
          inline
          label-width="100px"
          class="custom-formItem"
      >
        <el-form-item label="渠道名称" prop="Dname">
          <el-select
              v-model="formInnerThird.Dname"
              @change="channelSelect"
              filterable
              placeholder="请选择"
          >
            <el-option
                v-for="(item, i) in Cname"
                :key="i"
                :label="item.label"
                :value="item.type"
            >
            </el-option>
          </el-select>
          <!-- <el-input
            placeholder="请输入"
            v-model="formInnerThird.channelName"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="渠道方式" prop="channelWay">
          <el-select
              v-model="formInnerThird.channelWay"
              @change="channelEnSelect"
              filterable
              placeholder="请选择"
          >
            <el-option
                v-for="(item, i) in ENGname"
                :key="i"
                :label="item.label"
                :value="item"
            >
            </el-option>
          </el-select>
          <!-- <el-input
            placeholder="请输入"
            v-model="formInnerThird.channelName"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="渠道方式(英)" prop="channelWayEn">
          <el-input
              placeholder="标准"
              v-model="formInnerThird.channelWayEn"
          ></el-input>
        </el-form-item>
        <el-form-item label="运单号" prop="conveyNumber">
          <el-input
              placeholder="请输入"
              v-model.trim="formInnerThird.conveyNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="追踪号" prop="trackNumber">
          <el-input
              placeholder="请输入"
              v-model="formInnerThird.trackNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="打标地址" prop="conveyNumberUrl">
          <el-input
              placeholder="请输入"
              v-model="formInnerThird.conveyNumberUrl"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="实重" prop="applyWeight">
          <el-input placeholder="请输入" v-model="formInnerThird.applyWeight"></el-input>
        </el-form-item>
        <el-form-item label="材积重" prop="volumeWeight">
          <el-input placeholder="请输入" v-model="formInnerThird.volumeWeight"></el-input>
        </el-form-item>
        <el-form-item label="计费重" prop="actualWeight">
          <el-input placeholder="请输入" v-model="formInnerThird.actualWeight"></el-input>
        </el-form-item>
        <el-form-item label="物流费用" prop="applyPrice">
          <el-input placeholder="请输入" v-model="formInnerThird.applyPrice"></el-input>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addThirdDone" :loading="loadingThirdDone"
        >完 成</el-button
        >
			</span>
    </el-dialog>

    <el-dialog
        width="30%"
        title="添加备忘录"
        :visible.sync="Themomo"
        append-to-body
    >
      <div class="headTag">
        <div style="margin-top:15px;">
          <el-dropdown trigger="click" @command="GGTagsChange">
            <el-button type="primary">
              运单更新状态
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <div v-for="item in this.colorList3" :key="item.id">
                <el-dropdown-item
                    :command="item"
                    v-if="
										item.itemTypeId == 13 ||
											item.itemTypeId == 14 ||
											item.itemTypeId == 15 ||
											item.itemTypeId == 16 ||
											item.itemTypeId == 17 ||
											item.itemTypeId == 21
									"
                >{{ item.itemTypeName }}
                </el-dropdown-item
                >
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tag
              v-for="(tag, index) in GGtags"
              style="margin-left:5px;border:0;"
              @close="GGhandleClose(tag, index)"
              :color="tag.itemName"
              :key="tag.id"
              closable
              effect="dark"
              size="small"
              :type="tag.type"
          >{{ tag.itemTypeName }}
          </el-tag
          >
        </div>
      </div>
      <div style="margin-top:15px;">
        <el-upload
            ref="upload"
            :action="action"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :headers="customHeaders"
        >
          <i class="el-icon-plus" style="color: #0724ef;"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible1" append-to-body>
          <img width="100%" :src="dialogImageUrl" alt/>
        </el-dialog>
      </div>
      <div style="margin-top:20px;">
        <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
            placeholder="请输入内容"
            v-model="textarea1"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="Themomo = false">取 消</el-button>
        <el-button type="primary" @click="AddMomo">添加</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="originalVisible" width="540px" append-to-body>
      <img style="width: 500px;height: 500px;" :src="originalImg" alt/>
    </el-dialog>

    <el-dialog
        width="40%"
        title="处理"
        :visible.sync="ToDealWith"
        append-to-body
    >
      <div class="headTag">
        <div
            style="margin-top:15px;"
            v-if="this.openWithGGTags !== null"
        >
          <span>国际运单标记：</span>
          <el-tag
              v-for="(tag, index) in this.openWithGGTags"
              style="margin-left:5px;border:0;"
              @close="delGGTags(tag, index)"
              :color="tag.itemName"
              :key="tag.id"
              closable
              effect="dark"
              size="small"
              :type="tag.type"
          >{{ tag.itemTypeName }}
          </el-tag
          >
        </div>
      </div>

      <div style="margin-top:15px;">
        <el-upload
            ref="upload"
            :action="action"
            list-type="picture-card"
            :on-success="handleAvatarSuccess2"
            :on-preview="handlePictureCardPreview2"
            :on-remove="handleRemove2"
            :headers="customHeaders"
        >
          <i class="el-icon-plus" style="color: #0724ef;"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible2" append-to-body>
          <img width="100%" :src="dialogImageUrl2" alt/>
        </el-dialog>
      </div>
      <div style="margin-top:20px;">
        <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
            placeholder="请输入内容"
            v-model="textarea2"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SubEnd">提交并完结</el-button>
        <el-button type="primary" @click="SubNoEnd"
        >提交未完结
        </el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import {ajaxPost, Baseurl} from '@/api/api/api'
import {printInfo, increaseNum} from '@/utils/common.js'
import InternationalChannel from './InternationalChannel'
import {ALL} from '../../webChat/js/channel'

export default {
  name: 'Informationcheck',
  props: {
    UserInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    pageRadio: {
      type: String,
      default: '',
    },
  },
  components: {
    InternationalChannel,
  },
  data() {
    return {
      Cname: [
        {
          label: '递四方速递',
          type: 'DiSiFang',
        },
        {
          label: 'Yun Express',
          type: 'YunTu',
        },
        {
          label: 'Yanwen',
          type: 'YanWen',
        },

        {
          label: 'SFC',
          type: 'SanTai',
        },
        {
          label: 'UPS',
          type: 'UPS',
        },
        {
          label: 'DHL',
          type: 'DHL',
        },
        {
          label: 'DPD',
          type: 'DPD',
        },
        {
          label: 'GLS',
          type: 'GLS',
        },
        {
          label: 'FedEx',
          type: 'FedEx',
        },
        {
          label: '其他',
          type: 'other',
        },
      ],
      ENGname: [],
      id: '',
      dialogVisible: false,
      innerVisible: false,
      innerThirdVisible: false,
      loadingThirdDone: false,
      infoData: {},

      // 运单号
      conveyNumber: '',
      // 追踪号
      trackNumber: '',
      channelId: '',
      formInnerThird: {
        // channelWay: "",
        // conveyNumber: "",
        // trackNumber: "",
        // applyWeight: "",
        // actualWeight: "",
        // volumeWeight: "",
        // applyPrice: "",
        Dname: '',
        channelWayEn: '',
        channelName: '',
        channelWay: '',
        conveyNumber: '',
        trackNumber: '',
        conveyNumberUrl: '',
      },
      // rulesInner2: {
      //     stateOrRegion: [{ required: true, message: "州输入有误", trigger: "change" }],
      //     city: [{ required: true, message: "市输入有误", trigger: "blur" }],
      //     name: [{ required: true, message: "收件人输入有误", trigger: "blur" }],
      //     phone: [{ required: true, message: "TEL输入有误", trigger: "blur" }],
      //     postalCode: [{ required: true, message: "ZIP输入有误", trigger: "blur" }],
      //     addressLine1: [{ required: true, message: "地址1输入有误", trigger: "blur" }],
      // },
      rulesInnerThird: {
        Dname: [
          {
            required: true,
            message: '渠道名称输入有误',
            trigger: 'change',
          },
        ],
        channelWayEn: [
          {
            required: true,
            message: '渠道方式(英)输入有误',
            trigger: 'blur',
          },
        ],
        conveyNumber: [
          {
            required: true,
            message: '运单号输入有误',
            trigger: 'blur',
          },
        ],
      },

      isReceiverEdit: false,
      isCreateWaybill: false,
      isInfoAddressShow: false,

      momoList: [],
      Themomo: false,
      action: Baseurl + 'imageController/uploadImage',
      customHeaders: {token: localStorage.getItem('token')},
      imageData: [],
      imageData1: [],
      images: [],
      images1: [],
      textarea1: '',
      textarea2: '',
      dialogVisible1: false,
      dialogVisible2: false,
      dialogImageUrl: '',
      dialogImageUrl2: '',

      colorList3: [],
      sondata: '',
      parentType: '',

      originalImg: '',
      originalVisible: false,
      GGtags: [],
      openWith: '',
      openWithGGTags: '',
      remarkStatusNo: '',
      deleteChannelMark: [],
      ToDealWith: false,
      loadingInfo: false,
      InRemarks: false,
      remarksInput: '',
      RemarkList: [],
    }
  },
  computed: {
    infoChannel() {
      return Object.keys(this.infoData).length
          ? this.infoData.orderChannels
          : {}
    },
    storageInfo() {
      if (this.pageRadio === 'add') {
        return this.infoData.purchaseItems || []
      } else if (this.pageRadio === 'revise') {
        return this.infoData.purchases || []
      } else {
        return []
      }
    },
    infoAddress() {
      // console.log(JSON.parse(JSON.stringify(this.infoData.address)))
      return this.infoData.address || {}
    },
  },
  methods: {
    channelSelect(item) {
      // console.log(item)

      this.Cname.forEach((element) => {
        if (item == element.type) {
          this.formInnerThird.channelName = element.label
        }
      })
      this.ENGname = ALL[item]
      this.formInnerThird.channelWay = ''
      this.formInnerThird.channelWayEn = ''
    },
    channelEnSelect(item) {
      this.formInnerThird.channelWayEn = item.value
    },
    // printInfo,
    // increaseNum,
    async openPrintPage(item) {
      if (item.type == 12) {
        window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 13) {
        window.open('http://129.204.214.77:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 15 || item.type == 16) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
          window.open(item.conveyNumberUrl);
        } else {
          this.$message.error('暂无面单！')
        }
      } else if (item.type == 17) {
        window.open('http://47.96.42.132:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 18) {
        let API = Baseurl + 'baidian_order/getOrderLable'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          window.open(res.data)
        })
      } else if (item.type == 19) {
        let API = Baseurl + 'wanLeaderTypeController/getWanLeaderLabal'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 20 || item.type == 24) {
        window.open('http://1.14.254.116:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 21) {
        window.open('http://106.52.235.113:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 22) {
        let API = Baseurl + 'jiTuTypeController/getPrintUrl'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 23) {
        let API = Baseurl + 'udaTypeController/getUdaLabal'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 25 || item.type == 26) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
          window.open(item.conveyNumberUrl);
        } else {
          window.open('http://159.75.205.97:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
        }
      } else if (item.type == 27) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        } else {
          let API = Baseurl + 'dealfyController/getWaybill'
          ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 28) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        } else {
          let API = Baseurl + 'cainiaoOrderController/getWaybill'
          ajaxPost(API, { conveyNumber: item.conveyNumber, type: 28 }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 29) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        }
      } else if (item.type == 30) {
        window.open('http://43.139.202.31:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 31) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        } else {
          let API = Baseurl + 'cainiaoOrderController/getWaybill'
          ajaxPost(API, { conveyNumber: item.conveyNumber, type: 31 }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 32) {
        if (item.channelWayEn == 'AE_GLOBAL_JIT') {
             let API = Baseurl + 'aliexpressSemiHostingCollection/getShippingMarkPdf'
          ajaxPost(API, { sellerId: this.infoData.sellerId, purchaseOrderNo: item.fulfillmentId }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        } else {
          let API = Baseurl + 'aliexpressLogistics/getPrintinfo'
          ajaxPost(API, { international_logistics_id: item.conveyNumber, sellerId: this.infoData.sellerId }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 33) {
        let API = Baseurl + 'walmartShipping/downloadLabel'
        // console.log(this.infoData);
        ajaxPost(API, { sellerId: this.infoData.sellerId, trackingNo: item.conveyNumber, carrierShortName: item.channelName }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 34) {
        let API = Baseurl + 'shangYiTypeController/getOrderLabel'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else {
        await printInfo(item)
      }
      // if(item.type != 12) {
      // 	await printInfo(item)
      // } else {
      // 	window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      // }
      await increaseNum(item)
      item.printfCount += 1
    },
    init(row, type) {
      this.parentType = type
      this.sondata = row
      this.id = row.id
      this.isReceiverEdit = false
      this.isCreateWaybill = false
      this.infoData = row
      // this.infoData.amazonOrderId = row.amazonOrderId
      this.getInfo()
      this.TheMemo()
      this.internationalTag()
      this.RemarkListAjax()
    },
    close() {
      this.dialogVisible = false
      this.innerOutVisible = false
      this.isDoneBtnLoding = false
      this.infoData = {}
      // this.$emit('close')
    },
    getInfo() {
      let API = ''
      let paramsData = {}
      if (this.pageRadio === 'add') {
        API = Baseurl + 'logisticsController/getOrderDetailsByOrderId'
        paramsData.id = this.id
      } else if (this.pageRadio === 'revise') {
        API = Baseurl + 'logisticsController/getOrderChannelDetailById'
        paramsData.purchaseDemandId = this.id
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data} = res.data
        if (code === 200) {
          this.infoData = {...this.infoData, ...data}
          this.dialogVisible = true
        }
      })
    },
    getOrderMoney() {
      return new Promise((resolve, reject) => {
        const API =
            Baseurl + 'logisticsController/selectCompanyBalanceByOrder'
        const paramsData = {orderId: this.sondata.orderId}
        ajaxPost(API, paramsData).then((res) => {
          const {code, data} = res.data
          if (code === 200) {
            resolve(code)
          } else {
            reject(data)
          }
        })
      })
    },
    dialogInnerVisible() {
      // this.getOrderMoney().then(code => {
      //   if (code === 200) {
      //     this.formInner.productUrl = this.infoData.orderItems[0].saleLink;
      //     // this.formInner.sku = this.infoData.orderItems[0].sellerSKU;
      //     this.formInner.sku = '';
      //     this.formInner.unitPrice = COUNTRYLIST[this.infoData.countryMark] || "17";
      //     this.formInner.goodDeclareWorth = this.formInner.unitPrice * this.formInner.quantity;
      //     this.innerVisible = true;
      //   }
      // }).catch((err) => {
      //   this.$message.error(err || '网络出现问题，请稍候')
      // })
      const temporaryData = {
        infoData: this.infoData,
        roleId: this.UserInfo.rid,
      }
      this.$refs.InternationalChannel.initComponents(temporaryData)
    },
    createThirdChannel() {
      this.getOrderMoney()
          .then((code) => {
            if (code === 200) {
              this.innerThirdVisible = true
            }
          })
          .catch((err) => {
            this.$message.error(err || '网络出现问题，请稍候')
          })
    },
    // 渠道信息 确认
    channelChange() {
      this.$confirm('您确定要修改该货物的渠道信息吗？', '提示')
          .then(() => {
            this.$emit('channelChangeConfirm', this.infoData.id)
          })
          .catch(() => {
            this.$message('取消操作')
          })
    },
    // 新增第三方物流确认
    addThirdDone() {
      this.$refs.formInnerThird.validate((valida) => {
        if (valida) {
          let aaa =
              typeof this.formInnerThird.channelWay == 'object'
                  ? this.formInnerThird.channelWay.label
                  : this.formInnerThird.channelWay
          this.formInnerThird.channelWay = aaa
          let R = /[\u4E00-\u9FA5]/i
          if (R.test(this.formInnerThird.channelWayEn)) {
            this.$message.error('渠道方式(英)禁止输入汉字')
            return
          }

          const API =
              Baseurl + 'logisticsController/insertOrderChannel'
          const paramsData = {
            roleId: this.UserInfo.rid,
            companyId: this.UserInfo.company_id,
            orderId: this.infoData.id,
            applyFromStatus: this.sondata.applyFromStatus,
            channelName: '三方物流',
            type: '4',
            destinationCountryMark: this.infoData.address
                .countryCode1,
            ...this.formInnerThird,
          }
          // console.log(JSON.parse(JSON.stringify(this.UserInfo)))
          // console.log(JSON.parse(JSON.stringify(this.infoData)))
          // console.log(JSON.parse(JSON.stringify(paramsData)))
          // return
          this.loadingThirdDone = true
          ajaxPost(API, paramsData).then((res) => {
            this.loadingThirdDone = false
            const {code} = res.data
            if (code === 200) {
              this.$message.success('操作成功')
              this.innerThirdVisible = false
              this.getInfo()
              this.$emit('close')
            } else {
              this.$message.warning('操作失败')
            }
          })
        }
      })
    },
    // 作废
    toVoid(item) {
      const handleRequest = () => {
        const API = Baseurl + 'logisticsController/updateOrderChannel'
        const paramsData = {
          id: item.id,
          status: '1',
          operateType: '2',
          roleId: this.UserInfo.rid,
        }
        ajaxPost(API, paramsData).then((res) => {
          const {code, data} = res.data
          if (code === 200) {
            this.$message.success('操作成功')
            this.getInfo(this.infoData.id)
          } else {
            this.$message.error(data)
          }
        })
      }
      this.$confirm('您确定要作废该国际运单吗？', '提示').then(() => {
        handleRequest()
      })
    },
    dialogClose(type = '') {
      this.$refs.infoAddress.clearValidate()
      if (type === 'third') {
        this.$refs.formInnerThird.clearValidate()
        this.formInnerThird = this.$options.data().formInnerThird
      }
      // this.getInfo();
    },
    confirmOperate() {
      this.dialogVisible = false
      // this.$emit('confirm')
    },
    //渠道部备忘录列表
    TheMemo() {
      var obj = {
        documentId: this.id,
        remarkType: '3',
      }
      ajaxPost(Baseurl + 'orderController/selectRemarkList', obj).then(
          (res) => {
            if (res.data.code == 200) {
              this.momoList = res.data.data
              //   console.log(JSON.parse(JSON.stringify(this.momoList)))
            }
          }
      )
    },
    //图片上传
    handleAvatarSuccess(file) {
      this.imageData.push(file)
    },
    //图片移除
    handleRemove(file, fileList) {
      this.imageData = []
      for (var i = 0; i < fileList.length; i++) {
        this.imageData.push(fileList[i].response)
      }
    },
    //图片查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible1 = true
    },
    //添加备忘录
    AddMomo() {
      if (this.GGtags.length == 0 || this.GGtags == []) {
        this.$message.error('请添加国际运单标记！')
      } else if (this.textarea1 == '') {
        this.$message.error('请输入备忘录内容！')
      } else {
        this.MomoAjax()
      }
    },
    MomoAjax() {
      var str = JSON.parse(localStorage.getItem('role'))
      for (var i = 0; i < this.imageData.length; i++) {
        this.images.push(this.imageData[i].data)
      }

      var obj = {
        insertType: 1,
        documentId: this.sondata.id,
        orderId: this.sondata.id,
        remarkContent: this.textarea1,
        roleId: str.rid,
        remarkImages: this.images,
        remarkType: 3,
        remarkId: '',
        remarkOrder: '',
        remarkStatus: '',
        id: '',
        purchaseMarkItems: null,
        channelMarkItems: this.GGtags,
      }
      ajaxPost(Baseurl + 'orderController/insertRemark', obj).then(
          (res) => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: '添加备忘录成功!',
              })
              this.TheMemo()
            } else {
              this.$message.error(res.data.data)
            }
            this.$emit('close')
            this.GGtags = []
            this.images = []
            this.imageData = []
            this.textarea1 = ''
          }
      )
      this.$refs.upload.clearFiles()
      this.Themomo = false
    },
    GGTagsChange(val) {
      this.GGtags.push(val)
      // console.log(this.GGtags)
    },
    GGhandleClose(tag, index) {
      this.GGtags.splice(index, 1)
    },
    OpenToDealWith(val) {
      this.ToDealWith = true
      this.openWith = val
      this.openWithGGTags = JSON.parse(
          JSON.stringify(val.channelMarkItems)
      )
      console.log(val)
    },
    delGGTags(val, index) {
      console.log(val)
      this.openWithGGTags.splice(index, 1)
      this.deleteChannelMark.push(val.itemTypeId)
      console.log(this.openWithGGTags)
    },
    SubEnd() {
      this.remarkStatusNo = 3
      if (this.textarea2 == '') {
        this.$message.error('请输入内容！')
      } else {
        this.EndAjax()
      }
    },
    SubNoEnd() {
      this.remarkStatusNo = 2
      if (this.textarea2 == '') {
        this.$message.error('请输入内容！')
      } else {
        this.EndAjax()
      }
    },
    EndAjax() {
      var str = JSON.parse(localStorage.getItem('role'))
      for (var i = 0; i < this.imageData1.length; i++) {
        this.images1.push(this.imageData1[i].data)
      }

      var obj = {
        insertType: 2,
        documentId: this.sondata.id,
        orderId: this.sondata.id,
        remarkContent: this.textarea2,
        roleId: str.rid,
        remarkImages: this.images1,
        remarkType: 3,
        remarkId: this.openWith.remarkId,
        remarkOrder: this.openWith.remarkOrder,
        remarkStatus: this.remarkStatusNo,
        id: this.openWith.id,
        purchaseMarkItems: this.openWithGNTags,
        channelMarkItems: this.openWithGGTags,
        deletePurchaseMark: this.deletePurchaseMark,
        deleteChannelMark: this.deleteChannelMark,
      }
      ajaxPost(Baseurl + 'orderController/insertRemark', obj).then(
          (res) => {
            if (res.data.code == 200) {
              if (this.remarkStatusNo == 3) {
                this.$message({
                  type: 'success',
                  message: '提交并完结成功!',
                })
              } else if (this.remarkStatusNo == 2) {
                this.$message({
                  type: 'success',
                  message: '提交未完结成功!',
                })
              }
              this.TheMemo()
              this.$emit('edit')
              this.$emit('close')
            } else {
              this.$message.error(res.data.data)
            }
            this.deleteChannelMark = []
            this.deletePurchaseMark = []
            this.images1 = []
            this.imageData1 = []
            this.textarea2 = ''
          }
      )
      this.$refs.upload.clearFiles()
      this.ToDealWith = false
    },
    //国际运单标记
    internationalTag() {
      var obj = {itemCode: 'HYXUN0000012'}
      ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
          (res) => {
            if (res.data.code == 200) {
              this.colorList3 = res.data.data
              // console.log(this.colorList3)
            }
          }
      )
    },
    AddChannel() {
      // var arr_data = this.sondata.channelMarkList
      // if (arr_data.indexOf("13") === -1 && arr_data.indexOf("14") === -1) {
      //   this.$message.error('请先添加地址不全或者渠道更换的标记!');
      // }
      // else {
      this.Themomo = true
      // }
    },
    getOriginalImg(item) {
      // console.log(item)
      const API = Baseurl + 'productController/selectImagesByChildSku'
      const paramsData = {
        childSku: item.sellerSKU,
      }
      ajaxPost(API, paramsData).then((res) => {
        const {code, data, message} = res.data
        if (code === 200) {
          this.originalImg = data
          this.originalVisible = true
        } else {
          this.$message.error(message)
        }
      })
    },
    openLink(item) {
      window.open(item.saleLink)
    },
    handleAvatarSuccess2(file) {
      this.imageData1.push(file)
      console.log(this.imageData1)
    },
    handleRemove2(file, fileList) {
      this.imageData1 = []
      for (var i = 0; i < fileList.length; i++) {
        this.imageData1.push(fileList[i].response)
      }
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url
      this.dialogVisible2 = true
    },
    confirmAddresseeInfo() {
      const API = Baseurl + 'addressController/updateAddress'
      const paramsData = {
        countryCode: this.infoAddress.countryCode,
        stateOrRegion: this.infoAddress.stateOrRegion,
        name: this.infoAddress.name,
        addressLine1: this.infoAddress.addressLine1,
        addressLine2: this.infoAddress.addressLine2,
        addressLine3: this.infoAddress.addressLine3,
        postalCode: this.infoAddress.postalCode,
        city: this.infoAddress.city,
        phone: this.infoAddress.phone,
        id: this.infoAddress.id,
        amazonOrderId: this.infoAddress.amazonOrderId,
      }
      this.loadingInfo = true
      ajaxPost(API, paramsData).then((res) => {
        this.loadingInfo = false
        const {code, data} = res.data
        if (code === 200) {
          this.$message.success('修改成功')
          this.isReceiverEdit = false
        } else {
          this.$message.error(data)
        }
      })
    },
    RemarkListAjax() {
      const API =
          Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
      const paramsData = {
        orderId: this.sondata.orderId,
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.RemarkList = res.data.data
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    AddRemarks() {
      var str = JSON.parse(localStorage.getItem('role'))
      const API =
          Baseurl + 'logisticsRemarkController/insertLogisticsRemark'
      const paramsData = {
        orderId: this.sondata.orderId,
        remarkContent: this.remarksInput,
        amazonOrderId: this.sondata.amazonOrderId,
        roleId: str.rid,
        companyId: str.company_id,
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '添加物流内部备注成功',
          })
          this.RemarkListAjax()
        } else {
          this.$message.error(res.data.data)
        }
        this.remarksInput = ''
        this.InRemarks = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-container {
  padding: 0 20px;

  &.flex {
    display: flex;
    align-items: center;
  }
}

.inform {
  line-height: 30px;

  &.flex {
    display: flex;

    .title {
      flex-shrink: 0;
      font-weight: bold;
    }
  }
}

.right-btn-container {
  display: flex;
  justify-content: flex-end;
}

.el-popover {
  position: absolute;
  background: #fff;
  min-width: 200px;
  border: 1px solid #ebeef5;
  padding: 12px;
  left: 40%;
  right: 0%;
  top: -17%;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 9998;

  img {
    width: 90%;
  }
}

.padding0 {
  padding: 0;
}

.channel-flex {
  display: flex;
  margin-right: 20px;
}

.custom-formItem {
  ::v-deep {
    .el-form-item {
      width: 33.333%;
      margin-right: 0;
    }

    .el-form-item__content {
      width: calc(100% - 120px);

      .el-select,
      .el-date-editor,
      .el-input {
        width: 100%;
      }
    }

    .w100 {
      width: 100%;

      .el-form-item__content {
        width: 100%;
      }
    }
  }
}

.borbuttom {
  width: 100%;
  border-bottom: 1px solid #e4e7ed;
}

.borbuttom p {
  line-height: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
